import angular from 'angular';

angular.module('cloudX').factory('openNewAddressSvc', [openNewAddress]);

function openNewAddress() {
  // register the newAddress function from addressListDrv
  var openAddress = null;
  var callBacks = [];

  var openNewAddress = function(medium) {
    if (openAddress) {
      openAddress(medium);
    } else console.warn('function not registered in openNewAddressSvc');
  };

  return {
    register: function(scope, openAddressFunction) {
      openAddress = openAddressFunction;
      scope.$on('$destroy', function() {
        openAddress = null;
      });
    },
    registerCallback: function(scope, callBackFunc) {
      if (typeof callBackFunc !== 'function') return;
      callBacks.push(callBackFunc);
      scope.$on('$destroy', function() {
        var idx = callBacks.indexOf(callBackFunc);
        if (idx >= 0) callBacks.splice(idx, 1);
      });
    },
    openNewAddress: openNewAddress,
    notifyRefresh: function() {
      for (var i = 0; i < callBacks.length; i++) callBacks[i]();
    },
  };
}
